import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ImageDetail } from '@bookinglab/govbook-ui';
import { NavLink } from '@bookinglab/govbook-ui/layout';
import { HeaderComponent as GbHeaderComponent } from '@bookinglab/govbook-ui/layout';
import { CommonFunctionsService } from '../../services';

@Component({
	selector: 'app-header',
	standalone: true,
	imports: [CommonModule, RouterModule, GbHeaderComponent],
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
	constructor(private commonFunctionsService: CommonFunctionsService) {}

	get communicationLink(): any[] {
		return [
			'/',
			this.commonFunctionsService.getCompanyName(),
			this.commonFunctionsService.getCompanyId(),
			'communication',
		];
	}

	goToWebsite() {
		window.open('https://www.essex.gov.uk/', '_blank');
	}

	bookAppointment() {
		const site = window.location.origin;

		// if root url contains "staging"
		if (site.includes('staging')) {
			window.location.href =
				'https://westminster.ceremonies.registrars.staging.bookinglab.co.uk/start';
		} else {
			window.location.href =
				'https://westminster.ceremonies.registrars.bookinglab.co.uk/start';
		}
	}

	imageDetail: ImageDetail = {
		alt: 'Westminster Council - a day to remember homepage',
		src: 'wcc-nav-brand.svg',
		href: 'https://www.adaytoremember.london/'
	};

	navigation: NavLink[] = [
		{
			text: 'About Us',
			url: 'https://www.adaytoremember.london/about-us',
		},
		{
			text: 'The Process',
			url: 'https://www.adaytoremember.london/process',
		},
		{
			text: 'Ceremonies',
			url: 'https://www.adaytoremember.london/ceremonies',
		},
		{
			text: 'Citizenship',
			url: 'https://www.adaytoremember.london/citizenship',
		},
		{
			text: 'Venues',
			url: 'https://www.adaytoremember.london/venues',
		},
		{
			text: 'Suppliers',
			url: 'https://www.adaytoremember.london/suppliers',
		},
			{
			text: 'Blog',
			url: 'https://www.adaytoremember.london/blog',
		}
	];
}
